import "./loader.scss";

const Loader = () => {
  return (
    <div className="load_container">
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="ball"></div>
      <div className="shadow"></div>
      <div className="shadow"></div>
      <div className="shadow"></div>
    </div>
  );
};

export default Loader;
